/**
 * Agent Builder — design system tokens.
 * Same pattern as AI Listening theme.ts — scoped to Agent Builder components.
 */

export const ds = {
  sage50: '#f4f7f2', sage100: '#e6ede3', sage200: '#cddbc7',
  sage300: '#a8c49e', sage400: '#84a878', sage500: '#6b8f5e',
  sage600: '#5a7a4f', sage700: '#4a6341', sage800: '#3d5037', sage900: '#33422e',

  cream: '#faf9f5', creamDark: '#f3f1eb', warmWhite: '#ffffff',
  warm50: '#f8f7f4', warm100: '#efede8', warm200: '#e3e0d8',
  warm300: '#d1cdc3', warm400: '#b0aea5', warm500: '#8d8b83',
  warm600: '#6b6963', warm700: '#4a4944', warm800: '#2d2c28', warm900: '#1a1917',

  bg: '#faf9f5', surface: '#ffffff',
  textPrimary: '#1a1917', textSecondary: '#8d8b83', textMuted: '#b0aea5',
  border: 'rgba(0,0,0,0.08)', borderStrong: 'rgba(0,0,0,0.14)',
  bgHover: 'rgba(0,0,0,0.03)', bgSelected: 'rgba(107,143,94,0.08)',

  success: '#2e8b6e', successLight: 'rgba(46,139,110,0.08)',
  warning: '#c4873b', warningLight: 'rgba(196,135,59,0.08)',
  error: '#c45048', errorLight: 'rgba(196,80,72,0.08)',
  info: '#5b7fa6', infoLight: 'rgba(91,127,166,0.08)',

  // Harness badges
  mastra: '#8b5cf6', mastraBg: 'rgba(139,92,246,0.08)',
  custom: '#5b7fa6', customBg: 'rgba(91,127,166,0.08)',

  fontSerif: "'Source Serif 4', Georgia, Cambria, serif",
  fontSans: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",

  radiusSm: '6px', radius: '10px', radiusLg: '14px',
  shadowSm: '0 1px 3px rgba(0,0,0,0.06), 0 1px 2px rgba(0,0,0,0.04)',
  shadowMd: '0 4px 12px rgba(0,0,0,0.06)',
} as const

export const sxPageBg = {
  bgcolor: ds.bg, minHeight: '100vh', fontFamily: ds.fontSans, color: ds.textPrimary,
} as const

export const sxHeading = {
  fontFamily: ds.fontSerif, fontWeight: 600, letterSpacing: '-0.01em', color: ds.textPrimary,
} as const

export const sxCard = {
  bgcolor: ds.surface, border: `1px solid ${ds.border}`, borderRadius: ds.radiusLg, p: 2.5,
} as const

export const sxPrimaryBtn = {
  bgcolor: ds.sage500, color: '#fff', fontFamily: ds.fontSans, fontWeight: 600,
  fontSize: '0.8125rem', borderRadius: ds.radiusSm, textTransform: 'none',
  px: 2, py: 1, boxShadow: 'none',
  '&:hover': {bgcolor: ds.sage600, boxShadow: 'none'},
} as const

export const sxOutlinedBtn = {
  bgcolor: 'transparent', color: ds.textSecondary, fontFamily: ds.fontSans, fontWeight: 500,
  fontSize: '0.8125rem', borderRadius: ds.radiusSm, textTransform: 'none',
  border: `1px solid ${ds.border}`, px: 2, py: 0.75,
  '&:hover': {borderColor: ds.borderStrong, color: ds.textPrimary},
} as const
